import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import { statusColors, statusPanelSx, statusSectionTitleSx } from "../statusStyles";
import type { Claim, ClaimTranslator } from "../types";

type CoverageSummaryProps = {
  claim: Claim;
  isAwaitingReview: boolean;
  isReturnRequest: boolean;
  t: ClaimTranslator;
};

export const CoverageSummary = ({
  claim,
  isAwaitingReview,
  isReturnRequest,
  t,
}: CoverageSummaryProps) => {
  const rows = [
    {
      key: "protection",
      value: claim.order?.has_package_protection
        ? t("status.coverageActive")
        : t("status.coverageInactive"),
    },
  ];

  if (!isAwaitingReview && !isReturnRequest) {
    rows.push({
      key: "return",
      value: t("status.coverage.returnRequired"),
    });
  }

  return (
    <Box mb="16px" sx={statusPanelSx()}>
      <Typography
        variant="h6"
        mb="12px"
        fontSize="1.1rem"
        fontWeight={700}
        sx={statusSectionTitleSx}
      >
        {t("status.coverage.title")}
      </Typography>
      {rows.map((row) => (
        <Box
          key={row.key}
          display="flex"
          alignItems="flex-start"
          gap="8px"
          mb="8px"
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 18, color: statusColors.iconMuted, mt: "2px" }}
          />
          <Typography fontSize="15px" color={statusColors.metaText}>
            {row.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
